import 'trusted-security-policies';
import MyRoutes from "./routers";
import { useThemeMode } from "hooks/useThemeMode";
import "styles/styles.css"
function App() {
  useThemeMode().toDark();
  return (
    <>
     <div className="fullScreen bgColor text-base text-neutral-900 dark:text-neutral-200 font-body">
      <MyRoutes />
    </div>
    </>
  );
}

export default App;
